import { Box, Button, Grid2, Stack } from "@mui/material";
import { CustomImageView } from "../../component/CustomImageView";
import { APP_ICON_IMAGE } from "../../../data/constant/Constants";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import { CustomTextView } from "../../component/CustomTextView";
import { useTranslation } from "react-i18next";
import { CustomButtonView } from "../../component/CustomButtonView";
import { useNavigate } from "react-router-dom";
import { ROUTE_ENDPOINTS } from "../../../data/constant/RouteConstants";
import { openLink } from "../../../core/utils/Utils";
import { LandingViewModel } from "./LandingViewModel";
import { provideLoginAsGuestUseCase } from "../../di/UseCasesModule";

export function LandingView() {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  const navigate = useNavigate();
  const viewModel = LandingViewModel(provideLoginAsGuestUseCase());
  return (
    <Box
      sx={{
        background: "#750832",
        width: "100vw",
        height: "100vh",
        overflowY: "hidden",
        position: "relative",
      }}
    >
      <CustomImageView
        width={"100%"}
        height={"100%"}
        src={APP_ICON_IMAGE}
        scale={"contain"}
        props={{ position: "absolute", paddingBottom: width < 900 ? 20 : 0 }}
      />
      <Stack
        sx={{
          position: "relative",
          width: "100vw",
          height: "100vh",
          alignItems: "center",
          justifyContent: "end",
          zIndex: 10,
          p: 2,
        }}
      >
        <Stack
          sx={{
            background: "rgba(135,40,77,0.5)",
            backdropFilter: "blur(10px)",
            boxShadow: 2,
            borderRadius: 8,
            padding: 3,
            width: width < 700 ? "100%" : "75%",
          }}
        >
          <Grid2 container spacing={6} height={"100%"}>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 8, xl: 9 }}>
              <Stack justifyContent={"center"} height={"100%"}>
                <CustomTextView
                  variant="h5"
                  text={t("welcome_to_trivia_app")}
                  textColor="white"
                  fontWeight="bold"
                />
                <CustomTextView
                  variant={"h6"}
                  text={t("get_started_by_logging_in_signing_up")}
                  textColor="gray"
                />

                <Stack
                  direction={"row"}
                  maxWidth={"100%"}
                  alignItems={"center"}
                >
                  <Button
                    sx={{
                      width: 150,
                      height: 80,
                      padding: 0,
                      borderRadius: 20,
                    }}
                    onClick={() => {
                      openLink(
                        "https://apps.apple.com/us/app/%D8%A7%D9%84%D9%84%D9%8A-%D8%AA%D8%A8%D9%8A%D9%87/id6738418173?platform=iphone",
                        "_blank"
                      );
                    }}
                  >
                    <CustomImageView
                      width={"100%"}
                      height={"100%"}
                      scale="contain"
                      src={require("../../../assets/images/appstore_icon.png")}
                    />
                  </Button>

                  <Button
                    sx={{
                      width: 150,
                      height: 80,
                      padding: 0,
                      borderRadius: 20,
                    }}
                  >
                    <CustomImageView
                      width={"100%"}
                      height={"100%"}
                      scale="contain"
                      src={require("../../../assets/images/playstore_icon.png")}
                    />
                  </Button>
                </Stack>
              </Stack>
            </Grid2>
            <Grid2
              size={{ xs: 12, sm: 12, md: 12, lg: 4, xl: 3 }}
              width={"100%"}
            >
              <Stack spacing={1} height={"100%"} justifyContent={"center"}>
                <CustomButtonView
                  text={t("login")}
                  onClick={() => {
                    navigate(ROUTE_ENDPOINTS.LOGIN);
                  }}
                  backgroundColor="white"
                  textColor={"black"}
                />

                <CustomButtonView
                  text={t("signup")}
                  onClick={() => {
                    navigate(ROUTE_ENDPOINTS.SIGNUP);
                  }}
                />
                <CustomButtonView
                  text={t("login_as_guest")}
                  onClick={viewModel.loginAsGuest}
                  backgroundColor="grey"
                  textColor={"white"}
                  fontWeight="normal"
                />
              </Stack>
            </Grid2>
          </Grid2>
        </Stack>
      </Stack>
    </Box>
  );
}
